export enum SocialProvider {
  google = 'google',
  facebook = 'facebook',
}
